import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface ITourStatiQuerySorter extends ISorter {
   id?: ISorterExpression;
   name?: ISorterExpression;
   beschreibung?: ISorterExpression;
}

export const TourStatiQuerySorterConfig: ISorterConfig = [
   SorterConfig('id', 'BESICHTIGUNGEN.Models.TOUR_STATUS.Propertys.ID.title'),
   SorterConfig('name', 'BESICHTIGUNGEN.Models.TOUR_STATUS.Propertys.NAME.title'),
   SorterConfig('beschreibung', 'BESICHTIGUNGEN.Models.TOUR_STATUS.Propertys.BESCHREIBUNG.title'),
];
